module.exports = __webpack_public_path__ + "media/newstyle/images/icon-twitter-purple-0527ee9358fcef6a34b79061800efcfa.svg";